import DashboardLayout from '../components/DashboardLayout';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Mail, ExternalLink, RefreshCw, LogIn, Shield } from 'lucide-react';
import { toast } from 'sonner';

const SUPPORT_EMAIL = 'support@shopmanager247.com';

const tips = [
  { icon: RefreshCw, title: 'Page not loading correctly?', desc: 'Try refreshing the page or clearing your browser cache.' },
  { icon: LogIn, title: 'Can\'t log in?', desc: 'Use the "Forgot Password" link on the login page to reset your credentials.' },
  { icon: Shield, title: 'Need to add or remove users?', desc: 'Go to the Users page to invite new team members or deactivate accounts.' },
];

export default function HelpContact() {
  const copyEmail = () => {
    navigator.clipboard.writeText(SUPPORT_EMAIL);
    toast.success('Email copied to clipboard');
  };

  return (
    <DashboardLayout>
      <div data-testid="help-contact-page" className="space-y-6 max-w-3xl">
        <div>
          <h3 className="text-2xl font-bold text-slate-900 mb-2">Help & Support</h3>
          <p className="text-slate-600">Having an issue? We're here to help.</p>
        </div>

        <Card className="p-6 bg-white border border-slate-200 shadow-sm">
          <div className="flex items-start gap-4">
            <div className="bg-blue-100 p-3 rounded-md">
              <Mail size={24} className="text-blue-600" />
            </div>
            <div className="flex-1">
              <h4 className="text-lg font-semibold text-slate-900 mb-1">Contact Support</h4>
              <p className="text-sm text-slate-500 mb-4">
                Send us an email and we'll get back to you as soon as possible, typically within one business day.
              </p>
              <div className="flex items-center gap-3">
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-slate-900 text-white rounded-md hover:bg-slate-800 transition-colors text-sm font-medium"
                  data-testid="email-support-link"
                >
                  <Mail size={16} />
                  {SUPPORT_EMAIL}
                  <ExternalLink size={14} />
                </a>
                <Button variant="outline" size="sm" onClick={copyEmail} data-testid="copy-email-btn">
                  Copy Email
                </Button>
              </div>
            </div>
          </div>
        </Card>

        <Card className="p-6 bg-white border border-slate-200 shadow-sm">
          <h4 className="text-sm font-bold uppercase tracking-wider text-slate-500 mb-4">Quick Tips</h4>
          <div className="space-y-4">
            {tips.map((tip) => {
              const Icon = tip.icon;
              return (
                <div key={tip.title} className="flex items-start gap-3">
                  <div className="bg-slate-100 p-2 rounded-md mt-0.5">
                    <Icon size={16} className="text-slate-500" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-slate-800">{tip.title}</p>
                    <p className="text-sm text-slate-500">{tip.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </Card>

        <p className="text-xs text-slate-400 text-center">ShopManager247 &mdash; Shop Management Platform</p>
      </div>
    </DashboardLayout>
  );
}
